import { useQuery } from "react-query";
import { fetchValproData } from "./api";

export function useValpro(filters, options = {}) {
  return useQuery(
    ["fetchValproData", filters],
    () => fetchValproData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
